import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerSpacer from '../../../../components/custom_components/Spacer'
import PerText from '../../../../components/custom_components/Text'
import { ObjectiveInput } from '../../../../types'

interface OkrModalTitleProps {
  objective: ObjectiveInput
  title?: string
  isMonetary?: boolean
}

export const OkrModalTitle: FC<OkrModalTitleProps> = ({ objective, title, isMonetary }) => {
  const [t] = useTranslation()
  const showTitle = !!title && title.length > 0
  return (
    <>
      <PerSpacer>
        {!!objective && objective.title.length > 0 && (
          <PerText appearance="label" color="secondary" mb="xxs">
            {isMonetary || objective.targetAmount ? t('okr.objective.modal.monetaryHeadline') : t('okr.objective.modal.developHeadline')}
          </PerText>
        )}
        <PerText appearance="heading">{showTitle ? title : t('okr.objective.modal.defaultHeader')}</PerText>
      </PerSpacer>
    </>
  )
}
